module.exports = __webpack_public_path__ + "media/images/logos/University-of-Birmingham-4ec99527239c1b4d805b2d5a37703a6d.svg";